import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  // ...
} from '@angular/animations';
import { PafSetting, SharedDataService } from 'ngx-paf-common';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
@Component({
  selector: 'ymo-message',
  templateUrl: './ymo-message.component.html',
  styleUrls: ['./ymo-message.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({
        height: '30px',
        width: '400px',
        opacity: 1,
        backgroundColor: 'lightblue'
      })),
      state('closed', style({
        height: '0px',
        width: '0px',
        opacity: 0,
        backgroundColor: 'yellow'
      })),
      transition('open => closed', [
        animate('1s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ])]
    ),
    trigger('openCloseImage', [
      state('open', style({
        width: '400px',
        height: '200px',
        opacity: 1
      })),
      state('closed', style({
        width: '0px',
        height: '0px',
        opacity: 0
      })),
      transition('open => closed', [
        animate('1s')
      ]),
      transition('closed => open', [
        animate('1s')
      ]),
    ]), ,
    trigger('openCloseMessage', [
      state('open', style({
        transform: 'scale(1)',
        opacity: 1
      })),
      state('closed', style({
        transform: 'scale(0)',
        width: '0px',
        height: '0px',
        opacity: 0
      })),
      transition('open => closed', [
        animate('1s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
  ]
})
export class CadeauPierreComponent implements OnInit, OnDestroy {
  isTitleOpen = false;
  isImageOpen = false;
  isMessageOpen = false;

  Message: string = '';

  constructor(
    private router: Router,
    public sharedDatasSvc: SharedDataService) { }
  changeProfilSubscription?: Subscription;
  ngOnDestroy(): void {
    if (!!this.changeProfilSubscription) this.changeProfilSubscription.unsubscribe();
  }

  ngOnInit(): void {
    this.checkProfil();
  }

  checkProfil(): void {
    if (!this.sharedDatasSvc.profilLoaded || !this.sharedDatasSvc.profil) {
      this.changeProfilSubscription = this.sharedDatasSvc.loggedProfilChange.subscribe(res => {
        this.checkProfil();
      });
    } else {
      if (!this.sharedDatasSvc.pafEnvironment?.debug) {
        this.sharedDatasSvc.pafAlert('MSG_PROFIL_NON_AUTORISE_POUR_CET_ECRAN', (): void => {
          this.router.navigate(['suppliers']);
        });
      } else {
        this.Message = this.sharedDatasSvc.pafSettings.find((setting: PafSetting) => setting.KEY == 'YMO-Message')?.VALUE;
        setTimeout(() => { this.isTitleOpen = true; }, 500);
      }
    }
  }
  onOpenCloseDone($event: any) {
    if ($event.fromState == 'closed' && $event.toState == 'open') {
      if ($event.triggerName == 'openClose') this.isImageOpen = true;
      if ($event.triggerName == 'openCloseImage') this.isMessageOpen = true;
    }
  }


}
